/* ==============================================================================================
 * [ACCESS] NEW ISSUES CALENDAR COMPONENT
 * ============================================================================================== */

var Sushi, $ = window.jQuery;

var setupNewIssuesCalendarChildTables;

(function (Sushi) {
	"use strict";

	var rootEl = document.querySelector("[data-feature=newIssuesCalendar]");
	var datesApiEndpoint = "/json/access/newIssuesDates.json";

	if (!rootEl) {
		return;
	}

	var initialized = false;

	var tabbed = Sushi.getPluginInstance("Tabbed", document.querySelector("[data-plugin=Tabbed]"));

	var form = rootEl.querySelector("form");
	var availableMonths = [];

	var contentCalendar = rootEl.querySelector("[data-content=calendar]");
	var contentTable = rootEl.querySelector("[data-content=table]");
	var issuesTable = $("#newIssuesCalendarTable").DataTable();
	var dayElements = rootEl.querySelectorAll("[data-day-number]");

	var controller = rootEl.querySelector(".c-newIssuesController");
	var returnBtn = form.querySelector("[data-input=buttonReturn");

	var monthSelect = form.querySelector("[data-input=selectMonth");
	var prevMonthBtn = form.querySelector("[data-input=buttonPrev");
	var nextMonthBtn = form.querySelector("[data-input=buttonNext");
	var selectShowing = form.querySelector("[data-input=selectShowing");
	var reloadBtn = form.querySelector("[data-reload-new-issues]");

	var showCalendar = function () {
		contentTable.classList.remove("_df");
		contentTable.classList.add("_dn");
		contentCalendar.classList.remove("_dn");
		contentCalendar.classList.add("_df");
		controller.classList.remove("c-newIssuesController--showTable");
	};

	var showTable = function () {
		setTimeout(function () {
			// TODO: Update API endpoint URLs
			issuesTable.ajax.url("/json/access/newIssues.json").load(function () {
				setupNewIssuesCalendarChildTables("/json/access/issuerResultsIssues.json");
			});
		}, 1);

		contentTable.classList.remove("_dn");
		contentTable.classList.add("_df");
		contentCalendar.classList.remove("_df");
		contentCalendar.classList.add("_dn");
		controller.classList.add("c-newIssuesController--showTable");

		Sushi.Util.triggerWindowResize();
	};

	var submitForm = function () {
		initialized ? form.submit() : initialized = true;
	};

	var updateTablePageLength = function () {
		issuesTable.page.len(selectShowing.value).draw();
	};

	var moveMonthSelectIndex = function (step) {
		var currMonth = monthSelect.value;
		var currMonthIdx = -1;

		for (var i = 0, n = availableMonths.length; i < n; i++) {
			if (availableMonths[i].value === currMonth) {
				currMonthIdx = i;
				break;
			}
		}

		var targetIdx = currMonthIdx + step;

		if (targetIdx < 0) {
			targetIdx = 0;
		}

		if (targetIdx > availableMonths.length - 1) {
			targetIdx = availableMonths.length - 1;
		}

		monthSelect.value = availableMonths[targetIdx].value;
		Sushi.Events(monthSelect).trigger("change");
	};

	$.ajax(datesApiEndpoint, {
		/**
		 * @param {{ data: { months: array }}} response
		 */
		success: function (response) {
			availableMonths = response.data.months;

			for (var i = 0, n = availableMonths.length; i < n; i++) {
				var opt = document.createElement("option");

				opt.value = availableMonths[i].value;
				opt.text = availableMonths[i].label;
				monthSelect.add(opt);
			}

			Sushi.Events(monthSelect).trigger("change");
		},
	});

	Sushi.Dom.forEach(dayElements, function (dayEl) {
		dayEl.addEventListener("click", function () {
			showTable();
		});
	});

	var shouldCalendarView = parseInt(
		Sushi.Util.getUrlParameter(window.location, "calendar_view")
	) === 1;

	if (Sushi.Util.detectIe() && shouldCalendarView) {
		tabbed.activateTab("calendar_view");
	}

	returnBtn.addEventListener("click", showCalendar);
	reloadBtn.addEventListener("click", submitForm);
	monthSelect.addEventListener("change", submitForm);
	selectShowing.addEventListener("change", updateTablePageLength);
	prevMonthBtn.addEventListener("click", function () {
		moveMonthSelectIndex(-1);
	});
	nextMonthBtn.addEventListener("click", function () {
		moveMonthSelectIndex(1);
	});

})(Sushi || (Sushi = {}));
